module.exports = "/images/vendor/@sellers-shield-home-protection/ss-ui-kit/src/static/file-icons/excel.svg?bd4306e28621950615fae19940cb0e7c";